var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useCallback, useState, useMemo, useRef } from "react";
import { tabbable } from "tabbable";
import { useEventListener } from "./useEventListener";
export var useTrapFocus = function (options) {
    var node = useRef(null);
    var _a = useMemo(function () { return (__assign({ includeContainer: false, returnFocus: true, updateNodes: false, isActive: true }, options)); }, [options]), includeContainer = _a.includeContainer, returnFocus = _a.returnFocus, updateNodes = _a.updateNodes, isActive = _a.isActive;
    var _b = useState([]), tabbableNodes = _b[0], setTabbableNodes = _b[1];
    var previousFocusedNode = useRef(document.activeElement);
    var updateTabbableNodes = useCallback(function () {
        var current = node.current;
        if (current) {
            var getTabbableNodes = tabbable(current, { includeContainer: includeContainer });
            setTabbableNodes(getTabbableNodes);
            return getTabbableNodes;
        }
        return [];
    }, [includeContainer]);
    useEffect(function () {
        updateTabbableNodes();
        // when isActive changes, re-update tabbable nodes
    }, [isActive, updateTabbableNodes]);
    useEffect(function () {
        return function () {
            var current = previousFocusedNode.current;
            if (current && returnFocus)
                current.focus();
        };
    }, [returnFocus]);
    var handleKeydown = useCallback(function (event) {
        var key = event.key, shiftKey = event.shiftKey;
        var getTabbableNodes = tabbableNodes;
        if (updateNodes) {
            getTabbableNodes = updateTabbableNodes();
        }
        if (key === "Tab" && getTabbableNodes.length) {
            var firstNode = getTabbableNodes[0];
            var lastNode = getTabbableNodes[getTabbableNodes.length - 1];
            var activeElement = document.activeElement;
            if (!getTabbableNodes.includes(activeElement)) {
                event.preventDefault();
                shiftKey ? lastNode.focus() : firstNode.focus();
            }
            if (shiftKey && activeElement === firstNode) {
                event.preventDefault();
                lastNode.focus();
            }
            if (!shiftKey && activeElement === lastNode) {
                event.preventDefault();
                firstNode.focus();
            }
        }
    }, [tabbableNodes, updateNodes, updateTabbableNodes]);
    useEventListener({
        type: "keydown",
        listener: handleKeydown,
    });
    return node;
};
